import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useApp } from '../context/AppContext';
import './Login.css';
import ForgotPassword from './ForgotPassword';
import useAuth from '../hooks/useAuth';

const Login = () => {
  const navigate = useNavigate();
  const { login, user, error, clearError } = useApp();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useAuth({ skipDisclaimer: true }); // Skip disclaimer check for login page

  // If user is already logged in, redirect to disclaimer
  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    const disclaimerAccepted = localStorage.getItem('disclaimerAccepted');
    
    if (jwt && disclaimerAccepted === 'true') {
      navigate('/home');
    }
  }, [navigate]);

  // Display any errors from the context
  useEffect(() => {
    if (error) {
      setLocalError(error);
      clearError();
    }
  }, [error, clearError]);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!username.trim() || !password.trim()) {
      setLocalError('Please enter both username and password');
      return;
    }
    
    // Clear any previous errors
    setLocalError('');
    
    // Attempt to login
    const success = await login(username, password);
    
    if (success) {
      navigate('/disclaimer');
    }
  };

  if (showForgotPassword) {
    return <ForgotPassword onBack={() => setShowForgotPassword(false)} />;
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="logo">
          <img src="/assets/loginassets/COLA_interface_LogIn_LOGO-03.svg" alt="COLA Logo" />
        </div>
        
        <form className="login-form" onSubmit={handleLogin}>
          {localError && <div className="error-message">{localError}</div>}
          
          <div className="form-group">
            <label className="form-label">Username or Email</label>
            <input 
              type="text" 
              className="form-input" 
              placeholder="Enter your username or email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Password</label>
            <input 
              type="password" 
              className="form-input" 
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          
          <button type="submit" className="login-button">Log In</button>
          
          <div className="forgot-password">
            <a href="#" onClick={() => setShowForgotPassword(true)} >Forgot your password?</a>
          </div>
          
          <div className="register-link">
            Don't have an account? <a href="#">Register</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
